import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Paper, Rating, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { Control, useController } from 'react-hook-form';

import { CommonPageForm } from '../../../../../../../page-builder-v2.types';
import { styles } from './review-card.styles';

type Props = {
  productIdx: number;
  reviewIdx: number;
  onDelete: () => void;
  control: Control<CommonPageForm>;
};

const ReviewCard = ({ control, onDelete, productIdx, reviewIdx }: Props) => {
  const textField = useController({
    control,
    name: `products.${productIdx}.reviews.reviews.${reviewIdx}.review.text`,
  });
  const ratingField = useController({
    control,
    name: `products.${productIdx}.reviews.reviews.${reviewIdx}.review.rating`,
  });

  return (
    <Paper elevation={0} sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.dragHandle}>
          <DragIndicatorIcon fontSize="small" />
        </Box>
        <Tooltip title="Remove Review">
          <IconButton color="error" onClick={onDelete} size="small">
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Stack spacing={1.5} sx={styles.stack}>
        <Box>
          <Typography gutterBottom variant="subtitle2">
            Rating
          </Typography>
          <Box sx={styles.ratingRow}>
            <Rating
              onChange={(_, value) => ratingField.field.onChange(value)}
              precision={0.5}
              size="small"
              value={Number(ratingField.field.value) || 0}
            />
            <Typography color="text.secondary" variant="body2">
              {ratingField.field.value}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography gutterBottom variant="subtitle2">
            Review text
          </Typography>
          <TextField
            fullWidth
            multiline
            placeholder="Enter your text"
            size="small"
            sx={styles.textField}
            {...textField.field}
            error={textField.fieldState.invalid}
            helperText={textField.fieldState.error?.message}
          />
        </Box>
      </Stack>
    </Paper>
  );
};

export { ReviewCard };
